import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucChevronUp: FC<IconType> = ({
  iconColor = 'currentColor',
  ...svgProps
}) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 17 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M15.75 9.625C15.4336 9.625 15.1523 9.51953 14.9414 9.30859L9 3.36719L3.02344 9.30859C2.60156 9.76562 1.86328 9.76562 1.44141 9.30859C0.984375 8.88672 0.984375 8.14844 1.44141 7.72656L8.19141 0.976562C8.61328 0.519531 9.35156 0.519531 9.77344 0.976562L16.5234 7.72656C16.9805 8.14844 16.9805 8.88672 16.5234 9.30859C16.3125 9.51953 16.0312 9.625 15.75 9.625Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucChevronUp
